(function ($) {
	'use strict';

	const checkifSwiperNavRequiredSimple = (numSlides, nav, numToCheck = 1) => {
		if (numSlides <= numToCheck) {
			nav.css('display', 'none');
		} else {
			nav.removeAttr('style');
		}
	}

	const checkIfSwiperNavRequiredLock = (lockOrUnlock, sliderElement, nav) => {
		if ('lock' === lockOrUnlock) {
			nav.addClass('carousel-nav--hidden');

			sliderElement.removeAttribute('role');
			sliderElement.removeAttribute('aria-label');
			sliderElement.removeAttribute('aria-roledescription');
		} else if ('unlock' === lockOrUnlock) {
			nav.removeClass('carousel-nav--hidden');

			sliderElement.setAttribute('role', 'region');
			sliderElement.setAttribute('aria-label', 'Cards Carousel');
			sliderElement.setAttribute('aria-roledescription', 'carousel');
		}
	}

	const setSwiperNavAtBeginning = (sliderContainer) => {
		$('.js-carousel-nav-prev', sliderContainer).addClass('carousel-nav__button--disabled');
		$('.js-carousel-nav-prev', sliderContainer).attr('disabled', 'disabled');
	}

	const setSwiperNavAtEnd = (sliderContainer) => {
		$('.js-carousel-nav-next', sliderContainer).addClass('carousel-nav__button--disabled');
		$('.js-carousel-nav-next', sliderContainer).attr('disabled', 'disabled');
	}

	const setSwiperNavOtherClasses = (sliderContainer, swiper) => {
		if (!swiper.isBeginning) {
			$('.js-carousel-nav-prev', sliderContainer).removeClass('carousel-nav__button--disabled');
			$('.js-carousel-nav-prev', sliderContainer).removeAttr('disabled');
		}

		if (!swiper.isEnd) {
			$('.js-carousel-nav-next', sliderContainer).removeClass('carousel-nav__button--disabled');
			$('.js-carousel-nav-next', sliderContainer).removeAttr('disabled');
		}
	}

	const setupSwiperNavButtons = (sliderContainer, swiper) => {
		$('.js-carousel-nav-next', sliderContainer).each(function () {
			$(this).on('click', function () {
				swiper.slideNext();
			});
		});

		$('.js-carousel-nav-prev', sliderContainer).each(function () {
			$(this).on('click', function () {
				swiper.slidePrev();
			});
		});
	}

	window.checkifSwiperNavRequiredSimple = checkifSwiperNavRequiredSimple;
	window.checkIfSwiperNavRequiredLock = checkIfSwiperNavRequiredLock;
	window.setSwiperNavAtBeginning = setSwiperNavAtBeginning;
	window.setSwiperNavAtEnd = setSwiperNavAtEnd;
	window.setSwiperNavOtherClasses = setSwiperNavOtherClasses;
	window.setupSwiperNavButtons = setupSwiperNavButtons;
})(jQuery, document, window);
